import { render, staticRenderFns } from "./ButtonGoBack.vue?vue&type=template&id=6b6c966e&"
import script from "./ButtonGoBack.vue?vue&type=script&lang=js&"
export * from "./ButtonGoBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports